import { useTheme, Box } from '@mui/material'
import React from 'react'
import { useErrorSnackbar } from '../../hooks/useErrorSnackbar'
import { useTranslation } from 'react-i18next'

interface ImageDisplayProps {
  imageBase64: string
  altText?: string
  className?: string
  style?: React.CSSProperties
}

const ImageDisplay: React.FC<ImageDisplayProps> = ({
  imageBase64,
  altText = 'Displayed image',
  className = '',
  style = {},
}) => {
  const theme = useTheme()
  const { handleError } = useErrorSnackbar()
  const { t } = useTranslation()
  const defaultImageUploaderError = t(
    'ImageDisplay.View.Error',
    'Error displaying uploaded image.'
  )

  // Create data URL if base64 doesn't include prefix
  const getImageSrc = (base64: string): string => {
    if (base64.startsWith('data:')) {
      return base64
    }
    // Default to JPEG if no prefix is provided
    return `data:image/jpeg;base64,${base64}`
  }

  return (
    <Box
      className={`image-display-container ${className}`}
      sx={{
        background: theme.palette.background.paper,
        ...style,
      }}
    >
      <Box className="image-preview-container">
        <Box
          className="image-preview"
          sx={{
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: '8px',
            overflow: 'hidden',
            display: 'inline-block',
            maxWidth: '100%',
          }}
        >
          <img
            src={getImageSrc(imageBase64)}
            alt={altText}
            style={{
              maxWidth: '100%',
              height: 'auto',
              display: 'block',
            }}
            onError={async (e) => {
              await handleError(e, defaultImageUploaderError)
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default ImageDisplay
